module.exports = __webpack_public_path__ + "dotred1.png";